<template>
  <SelectField
    label=""
    :placeholder="placeholder"
    :floatingLabel="false"
    :options="availableRoomAmount"
    v-model="value__"
    size="md"
    @update:modelValue="change"
  />
</template>

<script>
import SelectField from '@/components/ui/form/select';
import { mapGetters } from 'vuex';
import { filter } from 'lodash';

export default {
  components: { SelectField },
  props: {
    modelValue: {
      // Change "value" to "modelValue" (Vue 3 convention)
      type: Number,
    },
    type: {
      type: String,
      default: 'max',
    },
    max: {
      type: Number,
    },
    min: {
      type: Number,
    },
  },
  data() {
    return {
      value__: this.modelValue, // Use "modelValue" instead of "value"
    };
  },
  computed: {
    placeholder() {
      return this.type === 'max' ? 'Max' : 'Min';
    },
    availableRoomAmount() {
      const roomList = this.$store.getters.config.roomAmount;;

      if (this.min) return roomList.filter(option => option.value >= this.min)
      else if (this.max) return roomList.filter(option => option.value <= this.max)
      else return roomList;
    },
  },
  watch: {
    modelValue(newValue) {
      // Watch "modelValue" instead of "value"
      this.value__ = newValue;
    },
  },
  methods: {
    change() {
      this.$emit('update:modelValue', this.value__); // Emit "update:modelValue"
    },
  },
};
</script>
